import React from 'react';
import {
  Box,
  Flex,
  Skeleton,
  SkeletonText,
  Stack,
  useColorModeValue,
} from '@chakra-ui/react';

import AnalyticsPage from '../../layout/IntegraAppPage';

const UsuarioDetalhesSkeleton: React.FC = () => {
  const pageBg = useColorModeValue('#EEF5F9', 'gray.900');
  const cardBg = useColorModeValue('white', 'gray.800');
  const borderColor = useColorModeValue('gray.200', 'gray.700');

  return (
    <AnalyticsPage>
      <Box bg={pageBg} minH="100vh" p={6}>
        <Flex align="center" mb={6} gap={4}>
          <Skeleton boxSize="40px" borderRadius="full" />

          <Box>
            <Skeleton height="20px" width="240px" mb={2} />
            <Skeleton height="12px" width="180px" />
          </Box>
        </Flex>

        <Stack spacing={6}>
          {[1, 2, 3].map(item => (
            <Box
              key={item}
              bg={cardBg}
              borderRadius="lg"
              border="1px"
              borderColor={borderColor}
              shadow="sm"
              p={5}
            >
              <Skeleton height="18px" width="180px" mb={2} />
              <Skeleton height="12px" width="260px" mb={6} />
              <SkeletonText noOfLines={3} spacing="4" />
            </Box>
          ))}
        </Stack>
      </Box>
    </AnalyticsPage>
  );
};

export default UsuarioDetalhesSkeleton;
